import React from 'react'

import { Tooltip } from '../tooltip'
import * as S from './label.styled'
import { LabelProps } from './label.types'

export const Label = ({
  children,
  tooltip,
  disabled = false,
  hasError = false,
  required = false,
  size = 'medium',
  ...props
}: LabelProps) => {
  return (
    <S.Label
      {...props}
      $size={size}
      $disabled={disabled}
      $hasError={hasError}
      data-component-id="Label"
    >
      {children}
      {required && <span aria-hidden="true">*</span>}
      {tooltip && <Tooltip>{tooltip}</Tooltip>}
    </S.Label>
  )
}
